export class AddLicenseHolderToVaultEntry {
    customerId: number;
    encryptionKey: string;
    dataKey: string;
    role: number;
}